/**
 * BUG-123 / ADR-027 — what pressing Approve in the post drawer has to do.
 *
 * Approve used to call the server with nothing but "approve": a time or text
 * typed into the drawer and not saved was dropped, and a draft with no time
 * was posted on the spot. Five Notes for one week's Deep Dives went out on one
 * Monday that way. The server now refuses to post a no-time or past-time draft
 * unless told `post_now` (409 needs_time); this decides, from the drawer's own
 * state, whether to save first, whether to ask before posting now, and whether
 * to warn about a Note that has no link to its article yet.
 */

export const SUBSTACK_NOTE_PLATFORM = "substack_note";

const HAS_LINK = /https?:\/\//i;

export interface ApprovePlan {
  /** The drawer has unsaved edits: save them before approving. */
  saveFirst: boolean;
  /** No time, or a time already passed: approving posts it now, so ask first. */
  needsPostNow: boolean;
  /** A Substack Note whose text has no link to its article yet. */
  warnNoLink: boolean;
}

export function planApprove(
  state: {
    dirty: boolean;
    /** The drawer's time field ("YYYY-MM-DDTHH:mm", local), "" when empty. */
    scheduledAt: string;
    platform: string;
    body: string;
  },
  now: number = Date.now()
): ApprovePlan {
  const when = state.scheduledAt ? new Date(state.scheduledAt).getTime() : NaN;
  return {
    saveFirst: state.dirty,
    needsPostNow: Number.isNaN(when) || when <= now,
    warnNoLink: state.platform === SUBSTACK_NOTE_PLATFORM && !HAS_LINK.test(state.body),
  };
}
